var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBxsCricketBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10306_24061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69394 1.28651L7.70021 1.28024L7.46333 1.15285C6.63636 0.708142 5.68807 0.541837 4.75912 0.678611C3.83017 0.815385 2.97005 1.24795 2.30635 1.91214C1.64265 2.57634 1.21071 3.43677 1.07463 4.36582C0.938539 5.29487 1.10554 6.24304 1.55087 7.06969L1.67974 7.30891L1.68577 7.30275L1.72111 7.35783C1.83123 7.52949 1.95449 7.69237 2.08977 7.84499L2.23072 8.00401L2.38091 7.8537L8.24758 1.98287L8.40006 1.83029L8.2364 1.68976C8.08466 1.55948 7.92486 1.4389 7.75794 1.32874L7.69394 1.28651ZM3.02928 8.67093L3.09328 8.71316L3.08701 8.71943L3.32388 8.84681C4.15086 9.29153 5.09915 9.45783 6.0281 9.32106C6.95705 9.18428 7.81717 8.75172 8.48087 8.08752C9.14457 7.42333 9.5765 6.56289 9.71259 5.63384C9.84868 4.70479 9.68167 3.75662 9.23635 2.92998L9.10748 2.69076L9.10145 2.69692L9.06611 2.64184C8.95599 2.47018 8.83273 2.3073 8.69745 2.15467L8.5565 1.99566L8.4063 2.14596L2.53964 8.0168L2.38716 8.16938L2.55082 8.30991C2.70256 8.44019 2.86236 8.56077 3.02928 8.67093Z",
    fill: "white",
    stroke: "#C52928",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10306_24061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0.394531)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsCricketBall);
export default __webpack_public_path__ + "static/media/bxs_cricket-ball.d9bf07d40acc86117219922cbe5233f0.svg";
export { ForwardRef as ReactComponent };